<template>
  <div>
    <div>
      <!---计费模式为：固定值---->
      <div
        v-if="chargeInfo.billingModel == billingModelDict.FIXED_FORMULA.value"
        class="m-b-10"
      >
        <div>1、收费标准：</div>
        <div class="exp-fixed" style="display:inline-block;">
          <span v-for="(item, index) in chargeInfo.fixedExpList" :key="index">
            {{ item.title }}
            <strong
              v-if="item.type === expTypeDict.CUSTOM.value && item.value"
              class="exp-value"
            >(值：{{ item.value }})</strong>
          </span>
        </div>
      </div>

      <!--------计费模式为：区间计费设置  或 累计计费设置--------->
      <!-- 计费基准值: 用以确认哪个值作为区间划分指标  -->
      <div
        v-if="chargeInfo.billingModel != billingModelDict.FIXED_FORMULA.value"
        class="table-width"
      >
        <div>
          1、收费标准：<strong>{{
            billingModelDict.translate(chargeInfo.billingModel).label || '-'
          }}</strong>
        </div>
        <el-table
          class="m-t-10 m-b-10"
          border
          :data="chargeInfo.itemList"
          size="medium"
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column
            :label="
              `${baseIndexDict.translate(chargeInfo.sectionMatchQuota)
                .label || ''}区间`
            "
            align="left"
          >
            <template slot-scope="{ row }">
              <span>{{
                Number(row.sectionEnd) === 0
                  ? `> ${row.sectionStart}`
                  : `${row.sectionStart} - ${row.sectionEnd}`
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计算公式">
            <template slot-scope="{ row }">
              <span
                v-for="(item, index) in row.expList"
                :key="index"
                class="mt5"
              >
                {{ item.title }}
                <span
                  v-if="item.type === expTypeDict.CUSTOM.value && item.value"
                  class="exp-value"
                >(值：{{ item.value }})</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <p>2、收费节点：采购人确定成交供应商后，供应商申请退回保证金前。</p>
    <p>3、收费方式：项目结束后，成交供应商需缴纳平台服务费。</p>
  </div>
</template>

<script>
import {
  billingModelDict,
  expTypeDict,
  baseIndexDict
} from '@/dictionary/company'

import { getChargeItemDetailApi } from '@/api/company'

export default {
  name: 'ServiceFeeRuleCopywriter',

  props: {
    configObj: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      billingModelDict,
      expTypeDict,
      baseIndexDict,

      chargeInfo: {}
    }
  },

  watch: {
    configObj: {
      handler: function(val) {
        this.getConfigDetail()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 获取公式详情
     */
    async getConfigDetail() {
      try {
        const _data = await getChargeItemDetailApi(this.configObj)
        this.chargeInfo = _data.data || {}
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  line-height: 1.5;
  span {
    display: block;
    line-height: 1.5;
    text-indent: 2em;
  }
}
</style>
